import ContractsMileageListRequest, {
  ContractsMileageListQueryParamsOrder,
} from "../../../../api/raily/contracts/mileage/list/contracts-mileage-list.request";
import ContractsMileageListParams, {
  ContractsMileageListParamsOrder,
} from "./contracts-mileage-list-params";

const createOrder = (
  order: ContractsMileageListParamsOrder | undefined,
): ContractsMileageListQueryParamsOrder | undefined => {
  switch (order) {
    case ContractsMileageListParamsOrder.COMPANY_NAME_ASC:
      return ContractsMileageListQueryParamsOrder.COMPANY_NAME_ASC;
    case ContractsMileageListParamsOrder.COMPANY_NAME_DESC:
      return ContractsMileageListQueryParamsOrder.COMPANY_NAME_DESC;
    case ContractsMileageListParamsOrder.VALID_SINCE_ASC:
      return ContractsMileageListQueryParamsOrder.VALID_SINCE_ASC;
    case ContractsMileageListParamsOrder.VALID_SINCE_DESC:
      return ContractsMileageListQueryParamsOrder.VALID_SINCE_DESC;
    case ContractsMileageListParamsOrder.VALID_TO_ASC:
      return ContractsMileageListQueryParamsOrder.VALID_TO_ASC;
    case ContractsMileageListParamsOrder.VALID_TO_DESC:
      return ContractsMileageListQueryParamsOrder.VALID_TO_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: ContractsMileageListParams,
): ContractsMileageListRequest => {
  return {
    cargoCompanyUuid: params.cargoCompanyUuid,
    isValid: params.isValid,
    page: params.page,
    pageSize: params.pageSize,
    cargoCompanyName: params.cargoCompanyName,
    order: createOrder(params.order),
  };
};

const contractsMileageListParamsFactory = {
  create,
};

export default contractsMileageListParamsFactory;
